import React from "react";
import { motion } from "framer-motion";

export default function OMnieSection() {
  return (
    <section id="o-mnie" className="py-14 sm:py-20 bg-white text-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 grid grid-cols-1 lg:grid-cols-2 gap-10 sm:gap-12 items-stretch">
        {/* TEKST */}
        <div className="flex flex-col justify-center h-full min-w-0 order-1 lg:order-1 text-left">
          <motion.h2
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
            viewport={{ once: true }}
            className="text-3xl xs:text-4xl md:text-5xl font-extrabold uppercase mb-8 sm:mb-10 text-left leading-tight drop-shadow-md text-black"
            style={{ color: '#000' }}
          >
            Poznajmy się bliżej
          </motion.h2>
          <div className="space-y-5 sm:space-y-6 text-base sm:text-lg leading-relaxed text-zinc-800 text-left relative w-full">
            <div className="absolute -inset-2 sm:-inset-4 md:-inset-8 bg-gradient-to-br from-orange-50/60 via-white/80 to-yellow-50/60 rounded-2xl blur-lg opacity-70 -z-10" />
            <p>
              Cześć! Nazywam się <strong className="text-orange-500">Filip Kusy</strong> i z pasją tworzę wydarzenia, które na długo zostają w pamięci — od eleganckich wesel, przez półmetki i studniówki, aż po eventy firmowe z charakterem.
            </p>
            <p>
              Jako <strong className="text-orange-500">DJ, wodzirej i prowadzący</strong> z wieloletnim doświadczeniem, łączę profesjonalizm z pozytywną energią, luzem i wyczuciem sytuacji.
            </p>
            <p>
              Każdą imprezę oprawiam kompleksowo — <em>muzycznie, wizualnie i organizacyjnie</em> — dopasowując każdy detal do Waszego stylu i oczekiwań.
            </p>
            <p className="font-semibold text-black-500">
              Szukacie kogoś, kto poprowadzi Wasz dzień z klasą i dobrą atmosferą? Zróbmy to razem.
            </p>
            {/* Przycisk kontaktu tylko na desktopie */}
            <div className="pt-2 sm:pt-4 hidden lg:block">
              <button
                onClick={() => {
                  const el = document.getElementById("kontakt");
                  if (el) el.scrollIntoView({ behavior: "smooth" });
                }}
                className="relative overflow-hidden px-6 py-3 sm:px-7 sm:py-3 rounded-md font-bold tracking-wide bg-black text-white shadow-lg transition-all duration-300 group focus:outline-none focus:ring-4 focus:ring-orange-300 w-full sm:w-auto"
                style={{ boxShadow: '0 4px 24px 0 #ff730060, 0 1px 4px 0 #00000030' }}
              >
                <span className="relative z-10">SKONTAKTUJ SIĘ ZE MNĄ</span>
                <span className="absolute inset-0 rounded-md border-2 border-orange-400 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none" style={{zIndex:2}} />
                <span className="absolute left-0 top-0 w-full h-full group-active:scale-95 transition-transform duration-150 pointer-events-none" style={{zIndex:3}} />
              </button>
            </div>
          </div>
        </div>
        {/* ZDJĘCIE */}
        <div className="flex flex-col items-center min-w-0 order-2 lg:order-2">
          <motion.div
            initial={{ boxShadow: '0 8px 32px 0 rgba(255,115,0,0.10)' }}
            whileHover={{ boxShadow: '0 12px 48px 0 rgba(255,115,0,0.25), 0 2px 8px 0 #ff7300a0' }}
            transition={{ duration: 0.5 }}
            className="w-full max-w-xs xs:max-w-sm sm:max-w-md h-full border-4 border-orange-400 rounded-xl overflow-hidden shadow-2xl flex group"
            style={{ boxShadow: '0 8px 32px 0 rgba(255,115,0,0.10)' }}
          >
            <img
              src="/assets/zamkniete/zamkniete15.webp"
              alt="DJ Filip Kusy"
              loading="lazy"
              width={800}
              height={1000}
              className="w-full object-cover object-center group-hover:scale-105 transition-transform duration-700"
            />
            <motion.div
              initial={{ opacity: 0.12 }}
              animate={{ opacity: [0.12, 0.22, 0.12] }}
              transition={{ repeat: Infinity, duration: 2, ease: "easeInOut" }}
              className="absolute inset-0 rounded-xl pointer-events-none border-4 border-yellow-100/40 border-dashed"
            />
          </motion.div>
          {/* CTA na mobile */}
          <div className="flex justify-center pt-2 sm:pt-4 w-full lg:hidden">
            <button
              onClick={() => {
                const el = document.getElementById("kontakt");
                if (el) el.scrollIntoView({ behavior: "smooth" });
              }}
              className="relative overflow-hidden px-6 py-3 sm:px-7 sm:py-3 rounded-md font-bold tracking-wide bg-black text-white shadow-lg transition-all duration-300 group focus:outline-none focus:ring-4 focus:ring-orange-300 w-full max-w-xs sm:w-auto"
              style={{ boxShadow: '0 4px 24px 0 #ff730060, 0 1px 4px 0 #00000030' }}
            >
              <span className="relative z-10">SKONTAKTUJ SIĘ ZE MNĄ</span>
              <span className="absolute inset-0 rounded-md border-2 border-orange-400 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none" style={{zIndex:2}} />
              <span className="absolute left-0 top-0 w-full h-full group-active:scale-95 transition-transform duration-150 pointer-events-none" style={{zIndex:3}} />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
